import * as React from 'react';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const SuccessNotificationContainer = ()=>{
    const intl = useIntl();
    const labels = React.useMemo(()=>({
            successNotification: intl.getLabel('cart.success.notification')
        })
    , [
        intl
    ]);
    return /*#__PURE__*/ React.createElement(Alert, {
        variant: "success",
        className: "alert-m-default"
    }, labels.successNotification);
};

export { SuccessNotificationContainer };
//# sourceMappingURL=SuccessNotificationContainer.js.map
